import styled from 'styled-components';
import { Button } from '../../../../input/Button';

export const SiteButton = styled(Button)
    .withConfig({ displayName: 'SiteButton' })
    .attrs((props) => ({
        ...props,
        variant: 'filled',
        color: 'primary',
        size: 'm',
        width: '100%',
        minHeight: '40px',
    }))``;
